import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DetalheBaseController } from '../../../helpers';
import { EmailService } from '../../../services';

@Component({
    templateUrl: 'boletoemail.edit.component.html',
})

export class BoletoEmailEditComponent extends DetalheBaseController {

    model: any = {};
    boletoatual: any;

    constructor(private router: Router, route: ActivatedRoute, private _emailService: EmailService) {
        super(route, _emailService);                
    }

    public salvar(form) { 
        this.boletoatual = JSON.parse(localStorage.getItem('currentboleto'));        
        this.boletoatual.email = form.mail;
            this.subPost = this.service.post(this.service._api, form).subscribe(result => {
                this._emailService.postBoletoEmail(this.boletoatual).subscribe(result => {                     
                    localStorage.removeItem('currentboleto');        
                    this.router.navigate(['/app/confirm']);   
                });        
            });
        
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/boletoemail/edit/boletoemail.edit.component.ts